import { ApiUnavailablePanel } from '../../components/ui/ApiUnavailablePanel';

export function AuditSettingsPage() {
  return (
    <div className="space-y-5">
      <ApiUnavailablePanel title="Audit & settings">
        Access history and admin controls are not available yet. No sample audit
        rows are shown.
      </ApiUnavailablePanel>
    </div>
  );
}
